import React, { useEffect, useRef, useState } from 'react'
import EmptyProfileImage from '../../images/navbar/empty-profile-image.png'
import showToast from '../../components/ShowToast';
import { API_BASE_URL } from '../../config';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import Loader from '../../components/Loader';

const JobReview = ({ data, jobData, isPopup }) =>
{
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [isViewReviewPopup, setIsViewReviewPopup] = useState(false);
    const [ratingQuality, setRatingQuality] = useState(0);
    const [ratingService, setRatingService] = useState(0);
    const [ratingCommunication, setRatingCommunication] = useState(0);
    const [ratingPromptness, setRatingPromptness] = useState(0);
    const [ratingCompletion, setRatingCompletion] = useState(0);
    const [ratingQualityHover, setRatingQualityHover] = useState(0);
    const [ratingServiceHover, setRatingServiceHover] = useState(0);
    const [ratingCommunicationHover, setRatingCommunicationHover] = useState(0);
    const [ratingPromptnessHover, setRatingPromptnessHover] = useState(0);
    const [ratingCompletionHover, setRatingCompletionHover] = useState(0);
    const [reviewDescription, setReviewDescription] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [reviewId, setReviewId] = useState(null);
    const [files, setFiles] = useState([]);
    const [filesToRemove, setFilesToRemove] = useState([]);
    const [filePreviews, setFilePreviews] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(isPopup);
    const [loading, setLoading] = useState(false);
    const [loggedUserProfilePic, setLoggedUserProfilePic] = useState(null);
    const [loggedUserName, setLoggedUserName] = useState(null);
    const [businessName, setBusinessName] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() =>
    {
        if (data && data.model)
        {
            setReviewId(data.model.reviewId);
            setRating(data.model.overallRating);
            setReviewDescription(data.model.description);
            setRatingCommunication(data.model.ratingCommunication);
            setRatingCompletion(data.model.ratingCompletion);
            setRatingPromptness(data.model.ratingPromptness);
            setRatingQuality(data.model.ratingQuality);
            setRatingService(data.model.ratingService);
            setUploadedFiles(data.model.mediaUrl);
        }

        setBusinessName(jobData?.businessName);
        setLoggedUserProfilePic(sessionStorage.getItem('userImage'));
        const token = jwtDecode(localStorage.getItem('token'));
        if (token)
            setLoggedUserName(token.UserName);
    }, []);

    const handleRemoveUploadedFile = (fileId) =>
    {
        setFilesToRemove([...filesToRemove, fileId]);
        setUploadedFiles(uploadedFiles.filter((file) => file.id !== fileId));
    };

    const handleRemoveFile = (index) =>
    {
        const newFilePreviews = filePreviews.filter((_, i) => i !== index);
        setFilePreviews(newFilePreviews);
        const newFiles = files.filter((_, i) => i !== index);
        setFiles(newFiles);
    };

    const handleCloseModalReview = () =>
    {
        setRating(0);
        setRatingCommunication(0);
        setRatingCompletion(0);
        setRatingPromptness(0);
        setRatingQuality(0);
        setRatingService(0);
        setReviewDescription(null);
        setFiles([]);
        setFilePreviews([]);
        setIsPopupOpen(false);
    }

    const handleFileChange = (e) =>
    {
        setFiles((prev) => [...prev, ...e.target.files]);
        const files = Array.from(e.target.files);
        const previews = files.map((file) => URL.createObjectURL(file));
        setFilePreviews((prev) => [...prev, ...previews]);
    };

    const handleBusinessReview = async (isPublish) =>
    {
        setLoading(true);
        const token = localStorage.getItem('token');
        const userId = token ? jwtDecode(token).nameid : null;

        if (!userId)
        {
            alert('User not authenticated. Please log in.');
            setLoading(false);
            return;
        }

        try
        {
            const formData = new FormData();
            if (reviewId != null)
                formData.append('reviewId', reviewId);
            formData.append('businessId', jobData?.assignedBusinessId || '');
            formData.append('jobId', jobData.job_id);
            formData.append('businessName', businessName);
            formData.append('description', reviewDescription || '');
            formData.append('overallRating', rating || 0);
            formData.append('userId', userId);
            formData.append('ratingQuality', ratingQuality || 0);
            formData.append('ratingService', ratingService || 0);
            formData.append('ratingCommunication', ratingCommunication || 0);
            formData.append('ratingPromptness', ratingPromptness || 0);
            formData.append('ratingCompletion', ratingCompletion || 0);

            files.forEach((file) => formData.append('files', file));
            filesToRemove.forEach((fileId) => formData.append('filesToRemove', fileId));

            const endpoint = isPublish
                ? `${API_BASE_URL}/api/BusinessReview/publish`
                : `${API_BASE_URL}/api/BusinessReview/save`;

            const response = await axios.post(endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200)
            {
                showToast('success', `${isPublish ? 'Published' : 'Drafted'} successfully!`);
                handleCloseModalReview();
                setFilesToRemove([]);
            }
        } catch (error)
        {
            showToast('Error saving business review:', error);
        } finally
        {
            setLoading(false);
        }
    };

    return (
        <>
            {isPopupOpen && (
                <div
                    className={`write-review-modal modal modal-backdrop-bg fade ${isPopupOpen ? 'show' : ''}`}
                    id="exampleModalToggle"
                    aria-hidden={!isPopupOpen}
                    aria-labelledby="exampleModalToggleLabel"
                    tabIndex="-1"
                    style={{ display: isPopupOpen ? 'block' : 'none' }}
                >
                    {loading ? <Loader /> : null}
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalToggleLabel">
                                    {businessName}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModalReview}
                                    aria-label="Close"
                                >
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="reviewer-detail">
                                    <div className="reviewer-name-image">
                                        <figure>
                                            <img
                                                src={loggedUserProfilePic == "null" ? EmptyProfileImage : loggedUserProfilePic}
                                                alt={loggedUserName} />
                                        </figure>
                                        <h3>{loggedUserName}</h3>
                                    </div>
                                </div>

                                <div class="rating-reviewer">
                                    <div className="star-rating">
                                        {Array.from({ length: 5 }, (_, index) =>
                                        {
                                            const starValue = index + 1;

                                            return (
                                                <svg
                                                    key={starValue}
                                                    width="54"
                                                    height="54"
                                                    viewBox="0 0 24 24"
                                                    fill={starValue <= (hover || rating) ? "#fd9e2b" : "#E4E4E4"}
                                                    onMouseEnter={() => setHover(starValue)}
                                                    onMouseLeave={() => setHover(0)}
                                                    onClick={() => setRating(starValue)}
                                                    style={{ cursor: "pointer", marginRight: "8px" }}
                                                >
                                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                </svg>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div className='review-rating-options'>
                                    <div className='rating-qns'>
                                        <label> Quality </label>
                                        <div>
                                            {Array.from({ length: 5 }, (_, index) =>
                                            {
                                                const starValue = index + 1;

                                                return (
                                                    <svg
                                                        key={starValue}
                                                        width="35"
                                                        height="35"
                                                        viewBox="0 0 24 24"
                                                        fill={starValue <= (ratingQualityHover || ratingQuality) ? "#fd9e2b" : "#E4E4E4"}
                                                        onMouseEnter={() => setRatingQualityHover(starValue)}
                                                        onMouseLeave={() => setRatingQualityHover(0)}
                                                        onClick={() => setRatingQuality(starValue)}
                                                        style={{ cursor: "pointer", marginRight: "8px" }}
                                                    >
                                                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                    </svg>
                                                );
                                            })}</div>
                                    </div>

                                    <div className='rating-qns'>
                                        <label>   Service </label><div>
                                            {Array.from({ length: 5 }, (_, index) =>
                                            {
                                                const starValue = index + 1;

                                                return (
                                                    <svg
                                                        key={starValue}
                                                        width="35"
                                                        height="35"
                                                        viewBox="0 0 24 24"
                                                        fill={starValue <= (ratingServiceHover || ratingService) ? "#fd9e2b" : "#E4E4E4"}
                                                        onMouseEnter={() => setRatingServiceHover(starValue)}
                                                        onMouseLeave={() => setRatingServiceHover(0)}
                                                        onClick={() => setRatingService(starValue)}
                                                        style={{ cursor: "pointer", marginRight: "8px" }}
                                                    >
                                                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                    </svg>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <div className='rating-qns'>
                                        <label>       Communication</label>
                                        <div>        {Array.from({ length: 5 }, (_, index) =>
                                        {
                                            const starValue = index + 1;

                                            return (
                                                <svg
                                                    key={starValue}
                                                    width="35"
                                                    height="35"
                                                    viewBox="0 0 24 24"
                                                    fill={starValue <= (ratingCommunicationHover || ratingCommunication) ? "#fd9e2b" : "#E4E4E4"}
                                                    onMouseEnter={() => setRatingCommunicationHover(starValue)}
                                                    onMouseLeave={() => setRatingCommunicationHover(0)}
                                                    onClick={() => setRatingCommunication(starValue)}
                                                    style={{ cursor: "pointer", marginRight: "8px" }}
                                                >
                                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                </svg>
                                            );
                                        })}</div>
                                    </div>
                                    <div className='rating-qns'>
                                        <label>   Promptness</label>
                                        <div>    {Array.from({ length: 5 }, (_, index) =>
                                        {
                                            const starValue = index + 1;

                                            return (
                                                <svg
                                                    key={starValue}
                                                    width="35"
                                                    height="35"
                                                    viewBox="0 0 24 24"
                                                    fill={starValue <= (ratingPromptnessHover || ratingPromptness) ? "#fd9e2b" : "#E4E4E4"}
                                                    onMouseEnter={() => setRatingPromptnessHover(starValue)}
                                                    onMouseLeave={() => setRatingPromptnessHover(0)}
                                                    onClick={() => setRatingPromptness(starValue)}
                                                    style={{ cursor: "pointer", marginRight: "8px" }}
                                                >
                                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                </svg>
                                            );
                                        })}</div>
                                    </div>

                                    <div className='rating-qns'>
                                        <label>     Completion </label>
                                        <div>   {Array.from({ length: 5 }, (_, index) =>
                                        {
                                            const starValue = index + 1;

                                            return (
                                                <svg
                                                    key={starValue}
                                                    width="35"
                                                    height="35"
                                                    viewBox="0 0 24 24"
                                                    fill={starValue <= (ratingCompletionHover || ratingCompletion) ? "#fd9e2b" : "#E4E4E4"}
                                                    onMouseEnter={() => setRatingCompletionHover(starValue)}
                                                    onMouseLeave={() => setRatingCompletionHover(0)}
                                                    onClick={() => setRatingCompletion(starValue)}
                                                    style={{ cursor: "pointer", marginRight: "8px" }}
                                                >
                                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                </svg>
                                            );
                                        })}</div>
                                    </div>

                                </div>

                                <div class="add-review-box">
                                    <textarea placeholder='Write your Review Here' className='form-control' value={reviewDescription} onChange={(e) => setReviewDescription(e.target.value)}></textarea>
                                </div>

                                <div class="custom-upload-file">
                                    <div class="drag-drop-button">
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            multiple
                                            accept="image/*,application/pdf"
                                            className="hidden"
                                            onChange={handleFileChange}
                                            id="file-upload"
                                        />

                                        <span >
                                            <label for="file-upload">
                                                <des title={files.length > 0 ? files.map(file => file.name).join(', ') : ''}>
                                                    {files.length > 1
                                                        ? `${files.length} files selected`
                                                        : files.length === 1
                                                            ? files[0].name
                                                            : 'Click here to attach photos'}
                                                </des>
                                            </label>
                                        </span>
                                    </div>
                                </div>

                                <div class="review-attachment">
                                    {filePreviews.map((file, index) => (
                                        <div key={index} className="uploaded-file-box d-flex align-items-center">
                                            <figure>
                                                <img src={file} alt={`preview-${index}`} />
                                                <svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleRemoveFile(index)}>
                                                    <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                                                </svg>
                                            </figure>
                                        </div>
                                    ))}

                                    {uploadedFiles.map((file, index) => (
                                        <div key={index} className="uploaded-file-box d-flex align-items-center">
                                            <figure>
                                                <img src={file.url} />
                                                <svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleRemoveUploadedFile(file.id)}>
                                                    <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                                                </svg>
                                            </figure>
                                        </div>
                                    ))}
                                </div>
                                <div class="post-review">
                                    <button type="button" class="draft-review-button" onClick={() => handleBusinessReview(false)}>
                                        Draft
                                    </button>
                                    <div className="add-review-buttons">
                                        <button type="button" class="cancel-review-button" onClick={() => handleCloseModalReview()}>
                                            Cancel
                                        </button>
                                        <button type="button" class="submit-review-button" onClick={() => handleBusinessReview(true)}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default JobReview
